<script setup lang="ts">
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed } from "vue";
import type { LogosBaseProps } from "./logos.interface";
import SectionContainer from "@/views/blocks/shared/section/container/SectionContainer.vue";

const props = defineProps<{
    block: PageBlock<LogosBaseProps>;
    pageColors: CssVarColors;
}>();

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);
</script>

<template>
    <SectionContainer
        :id="block.webId"
        class="lg:px-8 px-6"
        :backgroundColor="styleValues.background"
    >
        <div class="mx-auto max-w-7xl">
            <EditableElement
                v-if="!dataValues.title.isHidden"
                :blockId="block.id"
                fieldName="title"
            >
                <component
                    :is="block.dataValues.title.data.tag"
                    class="text-center text-lg/8 font-semibold"
                    :style="{
                        color: styleValues.text,
                    }"
                >
                    {{ dataValues.title.data.text }}
                </component>
            </EditableElement>
            <div class="mx-auto mt-10">
                <div class="flex flex-wrap justify-center gap-6 md:gap-8 lg:gap-10">
                    <EditableElement
                        v-for="logo in dataValues.logos.data.items"
                        :key="logo.id"
                        :blockId="block.id"
                        :fieldName="`logos_${logo.id}`"
                        :hideable="false"
                    >
                        <img
                            class="h-8 w-32 md:h-10 md:w-40 lg:h-12 lg:w-[211px] object-contain"
                            :src="logo.src"
                            :alt="logo.alt"
                            width="211"
                            height="48"
                        />
                    </EditableElement>
                </div>
            </div>
        </div>
    </SectionContainer>
</template>
